import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import ContentSections from './components/ContentSections';
import ArticleGrid from './components/ArticleGrid';
import JsonLd from '@/components/base/JsonLd';

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL;

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Sugargoo Spreadsheet Hub',
    url: siteUrl,
    logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/1fc56da0b352904925ac780066826afe.jpeg',
    description: 'The ultimate resource hub for Sugargoo Spreadsheet finds, reviews, shipping guides, coupons and buying tutorials.',
    sameAs: [
      'https://kaspreadsheet.com',
    ],
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'What is a Sugargoo Spreadsheet?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'A Sugargoo Spreadsheet is a curated product database containing organized listings with direct purchase links, pricing, sizing notes, quality ratings, and community feedback — designed to help Sugargoo shoppers find the best products quickly and efficiently.',
        },
      },
      {
        '@type': 'Question',
        name: 'How much does Sugargoo shipping cost?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Shipping costs vary based on destination, parcel weight, and shipping method. Express lines like DHL cost more but deliver in 5-10 days, while economy options are more affordable but take 20-60 days. Use our shipping cost guide for a detailed breakdown by method and destination.',
        },
      },
      {
        '@type': 'Question',
        name: 'Is Sugargoo legit and safe to use?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Yes, Sugargoo is a legitimate shopping agent with years of operational history. The platform provides buyer protection, warehouse quality control services with free QC photos, dispute resolution, and dedicated customer support to ensure a safe shopping experience for international buyers.',
        },
      },
      {
        '@type': 'Question',
        name: 'How do I find the best Sugargoo Spreadsheet products?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Start by browsing our curated category pages organized by product type. Use the spreadsheet filtering features to sort by quality rating, price range, and category. Focus on items with high community ratings and detailed sizing notes for the best experience.',
        },
      },
      {
        '@type': 'Question',
        name: 'Are there Sugargoo coupon codes available?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Yes, Sugargoo regularly offers various promotions including welcome bonuses for new users, shipping rebates on first parcels, VIP member discounts, and seasonal sales events. Check our coupon guide for the latest active discount codes and promotions.',
        },
      },
      {
        '@type': 'Question',
        name: 'Can beginners use the Sugargoo Spreadsheet?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Absolutely. The spreadsheet is designed to be beginner-friendly with clear category organization, sizing notes, and straightforward product links. It is the perfect starting point for anyone new to the Sugargoo platform. Check our beginner guide for a complete step-by-step tutorial.',
        },
      },
    ],
  };

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <JsonLd data={organizationSchema} />
      <JsonLd data={faqSchema} />
      <main>
        <Hero />
        <ContentSections />
        <ArticleGrid />
      </main>
      <Footer />
    </div>
  );
}